<template>
  <div>
    <div class="conversation-text">
        <div class="ctext-wrap">
            <div class="mb-1">
              <div v-html="preText(message.content)"></div>
              <span class="text-muted font-10">{{message.created_at | date_ago}}</span>
            </div>
            <message-files v-if="message.files && message.files.length"
              :files="message.files" @showImg="showImg($event)" />
            <div class="d-flex pt-1 mt-1 border-top">
                <slot name="actions"></slot>
            </div>
            <div v-if="message.replyer_id" class="pt-2">
              <h6 class="font-weight-medium my-0 text-sm">
                {{message.sender.role == 'buyer' ? 'Designer' : 'Buyer'}} replied
              </h6>
              <div>
                <div v-html="preText(message.reply)"></div>
                <small class="text-muted">{{message.replied_at | date_ago}}</small>
              </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import MessageFiles from "./MessageFiles.vue"

export default {
  components:{
      MessageFiles
  },
  props:{
      buyer: {
        required: true,
        type:Object
      },
      message: {
        required: true,
        type: Object
      },
      index: {
        required: true,
        type:Number
      },
  },
  methods:{
    showImg(payload){
      this.$emit("showImg", payload)
    }
  }
}
</script>
